import {useState} from 'react';
import {useEffect, FC} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Pagination, Navigation, Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import {hooks} from '../../hooks';
import {items} from '../../items';
import {custom} from '../../custom';
import {theme} from '../../constants';
import {actions} from '../../store/actions';
import {components} from '../../components';
import { BrandCard } from '../../items/BrandCard';
import { getHomePageData } from '../../services/getHomePageData';
import { FiShoppingBag, FiTag } from "react-icons/fi";

export const Home: FC = () => {
  const dispatch = hooks.useAppDispatch();
  const navigate = hooks.useAppNavigate();
  const [loading, setLoading] = useState<boolean>(true);
  const [activeIndex, setActiveIndex] = useState(0);
  const [productsCategoryData, setProductsCategoryData] = useState<any>([]);
  const [brandData, setBrandData] = useState<any>([]);
  const [bannersData, setBannersData] = useState<any>([]);
  const [carouselData, setCarouselData] = useState<any>([]);
  const [productsTopSellsData, setProductsTopSellsData] = useState<any>([]);
  const token = hooks.useAppSelector(state => state.auth.token);

useEffect(() => {
  const fetchData = async () => {
    await getHomePageData({
      token,
      dispatch,
      navigate,
      setLoading,
      setProductsCategoryData,
      setBannersData,
      setCarouselData,
      setBrandData,
      setProductsTopSellsData,
    });
  };

  fetchData();
  window.scrollTo(0, 0);
}, []);

const handleSlideChange = (swiper: any) => {
  setActiveIndex(swiper.activeIndex);
};

  const renderHeader = (): JSX.Element => {
    return <components.Header burger={true} basket={true} line={true} title={'فروشگاه عظیمی'} search={true}/>;
  };

  const settings = {
    spaceBetween: 10,
    slidesPerView: 1,
    loop: true,
    navigation: false, // پنهان کردن دکمه‌های ناوبری
    pagination: true, // پنهان کردن نقاط صفحه‌بندی
    autoplay: {
      delay: 3000, // زمان تأخیر بین اسلایدها به میلی‌ثانیه
      disableOnInteraction: false, // ادامه پخش خودکار پس از تعامل
    },
    // فعال کردن Swipeable
    simulateTouch: true,
    grabCursor: true,
    dir: 'rtl',
  };
  
  const renderDivider = (): JSX.Element => {
    return (
      <div
        className="w-full h-px max-w-6xl mx-auto my-5"
        style={{
          backgroundImage:
            'linear-gradient(90deg, rgba(149, 131, 198, 0) 1.46%, rgba(149, 131, 198, 0.6) 40.83%, rgba(149, 131, 198, 0.3) 65.57%, rgba(149, 131, 198, 0) 107.92%)',
        }}
      />
    );
  };

  const renderCarousel = (): JSX.Element => {
    return (
      <div style={{marginBottom: 22}}>
        <Swiper
          {...settings}
          modules={[Pagination, Navigation, Autoplay]}
          onSlideChange={handleSlideChange}
        >
          {carouselData?.map((item: any, index: any) => (
            <SwiperSlide 
            key={index}
            onClick={() =>
              navigate('/product', {state: {'item':{'id':item.product}}})
            }
            >
              <img
                src={item.image}
                alt='Carousel'
                style={{
                  width: '100%',
                  height: 300,
                  objectFit: 'contain',
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  };

  const renderIndicator = (): JSX.Element => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: 40,
        }}
      >
        {carouselData?.map((item: any, index: number) => {
          const isSelected = index === activeIndex;
          const indicatorStyle = {
            background: isSelected ? theme.colors.mainColor : '#E8EFF4',
            display: 'inline-block',
            width: 22,
            height: 6,
            margin: '0 6px',
            borderRadius: 6,
          };
          return <div style={indicatorStyle} key={index} />;
        })}
      </div>
    );
  };

  const renderProductsCategory = (): JSX.Element => {
    return (
      <div style={{marginBottom: 40, display: 'flex', flexDirection: 'column'}}>
        <components.BlockHeading
          title='دسته‌بندی محصولات'
          icon={<FiShoppingBag/>}
          containerStyle={{
            padding: '0px 20px 0px 14px',
            marginBottom: 14,
          }}
          viewAllOnClick={() => {
            dispatch(actions.resetFilters());
            navigate('/products-categories', {
              state: {products: productsCategoryData, title: 'Best sellers'},
            });
          }}
        />
        <custom.ScrollView style={{paddingLeft: 20, paddingRight: 20}}>
          {productsCategoryData?.map((item: any, index: number, arra: any) => {
            const isLast = index === arra.length - 1;
            return (
              <items.ProductCategoryCard
                key={item.id}
                isLast={isLast}
                item={item}
                version={1}
              />
            );
          })}
        </custom.ScrollView>
      </div>
    );
  };

  const renderBrands = (): JSX.Element => {
    return (
      <div style={{marginBottom: 40, display: 'flex', flexDirection: 'column'}}>
        <components.BlockHeading
          title='برند'
          icon={<FiTag/>}
          containerStyle={{
            padding: '0px 20px 0px 14px',
            marginBottom: 14,
          }}
          viewAllOnClick={() => {
            dispatch(actions.resetFilters());
            navigate('/brands', {
              state: {brands: brandData, title: 'Brands'},
            });
          }}
        />
        <custom.ScrollView style={{paddingLeft: 20, paddingRight: 20}}>
          {brandData?.map((item: any, index: number, arra: any) => {
            const isLast = index === arra.length - 1;
            return (
              <BrandCard
                key={item.id}
                isLast={isLast}
                item={item}
                version={1}
              />
            );
          })}
        </custom.ScrollView>
      </div>
    );
  };

  const renderProductsTopSell = (): JSX.Element => {
    return (
      <div style={{marginBottom: 40, display: 'flex', flexDirection: 'column'}}>
        <components.BlockHeading
          title='جدیدترین محصولات'
          containerStyle={{
            padding: '0px 20px 0px 14px',
            marginBottom: 14,
          }}
          viewAllOnClick={() => {
            dispatch(actions.resetFilters());
            navigate('/Shop', {
              state: {products: productsCategoryData, title: 'Best sellers'},
            });
          }}
        />
        <custom.ScrollView style={{paddingLeft: 20, paddingRight: 20}}>
          {productsTopSellsData?.map((item: any, index: number, arra: any) => {
            const isLast = index === arra.length - 1;
            return (
              <items.ProductHomeCard
                key={item.id}
                isLast={isLast}
                item={item}
              />
            );
          })}
        </custom.ScrollView>
      </div>
    );
  };

  // const renderBanner = (): JSX.Element => {
  //   const banner =
  //     bannersData && bannersData?.length > 0 ? bannersData[0]?.image : '';

  //   const matches = Array.isArray(productsData)
  //     ? productsData.filter(
  //         (product: any) => product.promotion === bannersData[0]?.promotion,
  //       )
  //     : [];
  //   return (
  //     <div style={{marginBottom: 40, display: 'flex'}}>
  //       <button
  //         onClick={() => {
  //           dispatch(actions.resetFilters());
  //           navigate('/Shop', {state: {products: matches}});
  //         }}
  //       >
  //         <img
  //           src={banner}
  //           alt='Banner'
  //           style={{
  //             width: '100%',
  //           }}
  //         />
  //       </button>
  //     </div>
  //   );
  // };


  const renderContent = () => {
    if (loading) return <components.Loading />;

    return (
      <main
        style={{
          paddingBottom: 64,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {renderCarousel()}
        {/* {renderIndicator()} */}
        {renderDivider()}
        {renderProductsCategory()}
        {renderDivider()}
        {renderBrands()}
        {renderDivider()}
        {/* {renderProductsTopSell()} */}
        {/* {renderBanner()} */}
        {/* {renderFeatured()} */}
      </main>
    );
  };

  const renderBottomTabBar = () => {
    return <components.BottomTabBar />;
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
      {renderBottomTabBar()}
    </>
  );
};
